import SVG from "react-inlinesvg";
import React, { useRef, useState } from "react";

const CustomPasswordField = ({feedback= false, ...props}) => {

    const [showPassword, setShowPassword] = useState(false);
    const [feedbackCheck, setFeedbackCheck] = useState({});
    const inputRef = useRef();

    const internalValidation = e => {
        
        const val = inputRef.current.value;
        const updateState = {};

        if (val.length > 0){
            updateState.min = val.length >= 8;
            updateState.lowercase = val.match(/[a-z]/);
            updateState.uppercase = val.match(/[A-Z]/);
            updateState.case = updateState.lowercase && updateState.uppercase;
            updateState.digit = val.match(/\d/);
            updateState.symbol = val.match(/[$@#$!%*?&+~|{}()^=\-`[\],_:;.<>]/);
        }

        if (props.onChange && e) {
            props.onChange(e);
        }

        setFeedbackCheck(updateState);
    }

    // Password Strength check against define conditions
    const checkField = (text, cond) => {
        if (feedbackCheck[cond]){
            return <p className="text-success pr-2">
                        <SVG
                            className="fill-current inline-block w-4 mr-1"
                            src="/assets/media/svg/tick-circle-fill.svg"
                        />
                        {text}
                    </p>
        }
        else {
            return <p className="text-grey-3 pr-2 dark:text-dark-2">
                        <SVG
                            className="stroke-current inline-block w-4 mr-1.5"
                            src="/assets/media/svg/tick-circle.svg"
                        />
                        {text}
                    </p>
        }
    }

    return <>
            <div className="relative w-full mt-2">
                <div className="absolute inset-y-0 right-0 flex items-center px-2">
                    <label 
                        className=" rounded px-2 py-1 text-sm text-gray-600 cursor-pointer z-50" 
                        onClick={_ => setShowPassword(!showPassword)}
                    >
                        <SVG
                            src={`/assets/media/svg/${showPassword ? "eye" : "eye-slash"}.svg`}
                            className="text-grey-2 stroke-current dark:text-dark-2 w-5"
                        />
                    </label>
                </div>
                <input 
                    minLength="8" 
                    required 
                    placeholder="Enter a valid password" 
                    className="form-input my-0 pr-10"
                    name="password"
                    autoComplete="new-password"
                    // pattern="/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@#$!%*?&+~|{}()^=\-`[\],_:;.<>/])[A-Za-z\d$@#$!%*?&+~|{}()^=\-`[\],_:;.<>/]{8,}$/"
                    pattern="^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$"
                    {...props}
                    type={showPassword ? "text" : "password"}
                    onChange={e => internalValidation(e)}
                    ref={inputRef}
                />
            </div>
            {
                feedback && <div className="pt-3 text-xs space-y-1 px-1 leading-5 font-medium">
                                    {checkField ("Password must contain at least 8 characters", "min")}
                                    {checkField ("Password must contain an UPPER & LOWER case alphabet", "case")}
                                    {checkField ("Password must contain at least one Number", "digit")}
                                    {checkField ("Password must contain at least one symbol", "symbol")}
                                </div>
            }
        </>

}

export default CustomPasswordField;